<template>
	<section class="calendario-fechas">
		<b-field label="Selecciona un periodo">
			<b-datepicker
				placeholder="Click para seleccionar..."
				v-model="fechasSeleccionadas"
				range
				@input="onFechaSeleccionada">
			</b-datepicker>
		</b-field>
		<div class="buttons">
			<b-button
				v-for="rango in rangosRapidos"
				:key="rango.label"
				size="is-small"
				type="is-info is-light"
				@click="aplicarRango(rango)"
			>
				{{ rango.label }}
			</b-button>
		</div>
	</section>
</template>
<script>
	export default {
		name: "BusquedaEnFecha",

		data: () => ({
			fechasSeleccionadas: [],
			rangosRapidos: [
				{ label: 'Hoy', dias: 0 },
				{ label: 'Ayer', dias: 1 },
				{ label: 'Últimos 7 días', dias: 7 },
				{ label: 'Este mes', dias: 'mes' },
				{ label: 'Últimos 30 días', dias: 30 },
			],
		}),

		methods: {
			onFechaSeleccionada() {
				const fechas = Array.isArray(this.fechasSeleccionadas) ? this.fechasSeleccionadas : []
				const normalizadas = fechas.length === 2 && fechas[0] && fechas[1]
					? fechas
					: [null, null]
				this.$emit("seleccionada", normalizadas)
			},

			calcularRango(rango) {
				const fin = new Date()
				const inicio = new Date()
				fin.setHours(0, 0, 0, 0)
				inicio.setHours(0, 0, 0, 0)

				if (rango.dias === 0) {
					// Hoy: ambos hoy
				} else if (rango.dias === 1) {
					inicio.setDate(inicio.getDate() - 1)
					fin.setDate(fin.getDate() - 1)
				} else if (rango.dias === 'mes') {
					inicio.setDate(1)
				} else {
					inicio.setDate(inicio.getDate() - rango.dias)
				}

				return [inicio, fin]
			},

			aplicarRango(rango) {
				const [inicio, fin] = this.calcularRango(rango)
				this.fechasSeleccionadas = [inicio, fin]
				this.onFechaSeleccionada()
			},
		}
	}
</script>